// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {}

.assign-work-order-modal .modal-dialog {
    max-width: 70%;
    margin-top: 3.3%;
}

.assign-work-order-modal .modal-dialog .modal-content {
    min-height: 60vh;
    padding: 0 51px;
}

.assign-work-order-modal .modal-dialog .wrapper-modal-header {
    width: 100%;
    padding: 60px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--neutral-color4);
}

.modal-header-title-section {
    display: grid;
    grid-template-columns: 1fr 0.5fr;
}

.modal-header-title-section .modal-title {
    font: normal normal bold 28px/34px Lato;
    letter-spacing: 0.28px;
    color: var(--neutral-color7);
}

.assign-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font: normal normal bold 14px/19px Lato;
    letter-spacing: 0.14px;
    color: var(--text-color2);
}

.assign-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {
    margin-right: 10px;
}

.modal-header-sign-section {
    display: flex;
    justify-content: center;
    /* grid-template-columns: 1fr 0.5fr; */
}
.sign-modal-footer-section {
    display: flex;
    column-gap: 10px;
}

.modal-body .wrapper-modal-body {
    width: 100%;
    height: 100%;
    display: grid;
    grid-row-gap: 25px;
}

.modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 10px;
}

.modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group:nth-child(3) {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 10px;
}

.modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group:last-child {
    grid-template-columns: 1fr;
    /* min-height: 68px; */
}

.modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group:last-child .form-group {
    max-height: 70px;
}

.modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group:last-child .form-group .form-control {
    height: 100%;
}

.modal-body .wrapper-modal-body .revart-back-modal-card-item-group {
    grid-template-columns: 1fr;
}

.modal-body .wrapper-modal-body .revart-back-modal-card-item-group.assign-supervisor-modal-card-item-group{
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
}

/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    .assign-work-order-modal .modal-dialog .modal-content {
        padding: 0 21px 20px 21px;
    }

    .assign-work-order-modal .modal-body {
        max-height: 100%;
    }

    .modal-footer .assign-btn-section {
        align-items: center;
    }

    .modal-footer .assign-btn-section span {
        display: flex;
        align-items: center;
    }

    .assign-work-order-modal .modal-header-title-section {
        grid-template-columns: 1fr 0.7fr;
        grid-column-gap: 10px;
    }

    .assign-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {
        font: normal normal medium 14px/19px Lato;
        letter-spacing: 0.14px;
        color: #666666;
    }

    .assign-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {
        overflow: hidden;
        max-width: 87px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .assign-work-order-modal .modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group{
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
    }
    .assign-work-order-modal .modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group .card-item-group{
        display: grid;
        text-align: start;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 5px;
    }
    .assign-work-order-modal .modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group:nth-child(3) .card-item-group{
        grid-template-columns: 1fr;
    }

    .modal-body .wrapper-modal-body .revart-back-modal-card-item-group.assign-supervisor-modal-card-item-group{
        grid-template-columns: 1fr;
        row-gap: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/AssignWorkOrderModal.css"],"names":[],"mappings":"AAAA,OAAO;;AAEP;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sCAAsC;AAC1C;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA,wCAAwC;AACxC;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,gCAAgC;QAChC,qBAAqB;IACzB;;IAEA;QACI,yCAAyC;QACzC,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;IACA;QACI,aAAa;QACb,iBAAiB;QACjB,8BAA8B;QAC9B,oBAAoB;IACxB;IACA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,aAAa;IACjB;AACJ","sourcesContent":[":root {}\r\n\r\n.assign-work-order-modal .modal-dialog {\r\n    max-width: 70%;\r\n    margin-top: 3.3%;\r\n}\r\n\r\n.assign-work-order-modal .modal-dialog .modal-content {\r\n    min-height: 60vh;\r\n    padding: 0 51px;\r\n}\r\n\r\n.assign-work-order-modal .modal-dialog .wrapper-modal-header {\r\n    width: 100%;\r\n    padding: 60px 0;\r\n    padding-bottom: 12px;\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n\r\n.modal-header-title-section {\r\n    display: grid;\r\n    grid-template-columns: 1fr 0.5fr;\r\n}\r\n\r\n.modal-header-title-section .modal-title {\r\n    font: normal normal bold 28px/34px Lato;\r\n    letter-spacing: 0.28px;\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.assign-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    font: normal normal bold 14px/19px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--text-color2);\r\n}\r\n\r\n.assign-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {\r\n    margin-right: 10px;\r\n}\r\n\r\n.modal-header-sign-section {\r\n    display: flex;\r\n    justify-content: center;\r\n    /* grid-template-columns: 1fr 0.5fr; */\r\n}\r\n.sign-modal-footer-section {\r\n    display: flex;\r\n    column-gap: 10px;\r\n}\r\n\r\n.modal-body .wrapper-modal-body {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    grid-row-gap: 25px;\r\n}\r\n\r\n.modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n.modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group:nth-child(3) {\r\n    grid-template-columns: repeat(3, 1fr);\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n.modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group:last-child {\r\n    grid-template-columns: 1fr;\r\n    /* min-height: 68px; */\r\n}\r\n\r\n.modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group:last-child .form-group {\r\n    max-height: 70px;\r\n}\r\n\r\n.modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group:last-child .form-group .form-control {\r\n    height: 100%;\r\n}\r\n\r\n.modal-body .wrapper-modal-body .revart-back-modal-card-item-group {\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n.modal-body .wrapper-modal-body .revart-back-modal-card-item-group.assign-supervisor-modal-card-item-group{\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    column-gap: 10px;\r\n}\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    .assign-work-order-modal .modal-dialog .modal-content {\r\n        padding: 0 21px 20px 21px;\r\n    }\r\n\r\n    .assign-work-order-modal .modal-body {\r\n        max-height: 100%;\r\n    }\r\n\r\n    .modal-footer .assign-btn-section {\r\n        align-items: center;\r\n    }\r\n\r\n    .modal-footer .assign-btn-section span {\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .assign-work-order-modal .modal-header-title-section {\r\n        grid-template-columns: 1fr 0.7fr;\r\n        grid-column-gap: 10px;\r\n    }\r\n\r\n    .assign-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {\r\n        font: normal normal medium 14px/19px Lato;\r\n        letter-spacing: 0.14px;\r\n        color: #666666;\r\n    }\r\n\r\n    .assign-work-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {\r\n        overflow: hidden;\r\n        max-width: 87px;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n    .assign-work-order-modal .modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group{\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n    }\r\n    .assign-work-order-modal .modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group .card-item-group{\r\n        display: grid;\r\n        text-align: start;\r\n        grid-template-columns: 1fr 1fr;\r\n        grid-column-gap: 5px;\r\n    }\r\n    .assign-work-order-modal .modal-body .wrapper-modal-body .assign-work-order-modal-card-item-group:nth-child(3) .card-item-group{\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .modal-body .wrapper-modal-body .revart-back-modal-card-item-group.assign-supervisor-modal-card-item-group{\r\n        grid-template-columns: 1fr;\r\n        row-gap: 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
